import React from 'react'
import { CountdownCircleTimer } from "react-countdown-circle-timer";
import { useSelector } from 'react-redux';
import moment from "moment";

const renderTime = ({ remainingTime }) => {
  const secToHours = (sec)=>{
    let days = Math.trunc(sec/86400);
    let labels = days==1?'Day':'Days';
    return days+labels;
  }
    return (
      <div className="timer">
        <div className="value" style={{fontSize:'14px', color:'grey', fontWeight:"bold"}}>{remainingTime>86400?secToHours(remainingTime):moment.utc(remainingTime*1000).format(remainingTime>3600?'H[h]':remainingTime>60?'mm[m]':'ss[s]')}</div>
        <div className="text" style={{fontSize:'12px', color:'grey'}}>left to</div>
        <div className="text" style={{fontSize:'12px', color:'grey'}}>answer</div>
      </div>
    );
  };
export default function Timer() {
  const editorState = useSelector(state=>state.editor);
  return (
    <div >
        <CountdownCircleTimer
          isPlaying
          duration={(editorState.data.expireSLA)}
          colors={["rgb(69, 204, 206)", "#F7B801", "#A30000", "#A30000"]}
          colorsTime={[10, 6, 3, 0]}
          onComplete={() => ({ shouldRepeat: false, delay: 1 })}
          size={80}
          strokeWidth={8}
          
        >
          {renderTime}
        </CountdownCircleTimer>
    </div>
  )
}
